import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import * as SecureStorage from 'secure-web-storage';
//const SecureStorage = require('secure-web-storage');
const SECRET_KEY = 'secret_key';

@Injectable({providedIn:'root'})
export class StorageService {
// eslint-disable-next-line @typescript-eslint/no-empty-function
constructor() { }
public secureStorage = new SecureStorage(localStorage, {
// Encrypt the localstorage data
encrypt: function encrypt(data) {
    data = CryptoJS.AES.encrypt(data, SECRET_KEY);
    data = data.toString();
    return data;
},
// Decrypt the encrypted data
decrypt: function decrypt(data) {
    data = CryptoJS.AES.decrypt(data, SECRET_KEY);
    data = data.toString(CryptoJS.enc.Utf8);
    return data;
}
});
}